import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Button, colors, Typography } from "@material-ui/core";
import {
  masqueradeToken,
  masqueradingMinutesLeft,
  stopMasquerading,
} from "../util";
import clsx from "clsx";
import { FilmNoirIcon } from "../components/icons/themes/windows10";
import { AlertManager, useAlert } from "react-alert";
import useAccountMetadata from "../hooks/useAccountMetadata";

function handleStopMasquerading(alert: AlertManager) {
  stopMasquerading();
  alert.success("You are no longer masquerading");
  setTimeout(() => window.location.reload(), 1000);
}

const useStyles = makeStyles((theme) => ({
  masqueradeWarning: {
    backgroundColor: colors.red[500],
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(0.5),
  },
  masqueradeWarningText: {
    color: "white",
    paddingTop: "2px",
  },
  masqueradeWarningIcon: {
    height: 18,
    marginRight: theme.spacing(0.5),
    marginTop: -theme.spacing(0.25),
    width: 18,
  },
  stopMasqueradingButton: {
    border: "1px solid white",
    color: "white",
    fontSize: theme.typography.fontSize * 0.75,
    minWidth: "4em",
    padding: theme.spacing(0),
  },
}));

function MasqueradeWarningBar() {
  const accountMetadata = useAccountMetadata();
  const alert = useAlert();
  const classes = useStyles();
  const whoAmI = masqueradeToken();
  const [minutesLeft, setMinutesLeft] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMinutesLeft(masqueradingMinutesLeft() ?? 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (whoAmI === null) {
    return null;
  }

  if (accountMetadata?.config?.disableMasqueradeWarningBanner) {
    return null;
  }

  return (
    <div className={clsx(classes.masqueradeWarning)}>
      <Typography
        variant="body2"
        className={clsx(classes.masqueradeWarningText)}
      >
        <FilmNoirIcon className={clsx(classes.masqueradeWarningIcon)} />
        WARNING: Masquerading as {whoAmI}.{" "}
        {minutesLeft > 0 && `${minutesLeft} minutes left.`}
      </Typography>

      <Button
        className={clsx(classes.stopMasqueradingButton)}
        onClick={() => handleStopMasquerading(alert)}
        size={"small"}
        title={"Stop masquerading"}
        variant={"outlined"}
      >
        Stop
      </Button>
    </div>
  );
}

export default MasqueradeWarningBar;
